import {
  CopyrightSection,
  CopyrightCompany,
} from 'components/CompleteFooter/CompleteFooter.styles';
import React from 'react';
import { getAppSettings } from 'utils/privateLabel';
import RenderItem from '../RenderItem';

const RenderCopyrightSection = (): React.ReactElement<any> => {
  const { terms, privacy, cookie, sellInfo, text } = getAppSettings()?.copyright;
  return (
    <CopyrightSection>
      <CopyrightCompany role='heading' aria-level='3'>
        {text} {new Date().getFullYear()}
      </CopyrightCompany>
      <RenderItem item={terms} />
      <RenderItem item={privacy} />
      <RenderItem item={cookie} />
      <RenderItem item={sellInfo} />
    </CopyrightSection>
  );
};

export default RenderCopyrightSection;
